"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typographyMixinValues = void 0;
const typography_mixins_1 = require("@deliveryhero/pd-bento-design-tokens/web/js/typography-mixins");
exports.typographyMixinValues = Object.assign(Object.assign({}, typography_mixins_1.typographyMixinValues), { 'link-sm': {
        fontSize: 14,
        fontWeight: 'light'
    } });
